"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestFailed = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
var _styles = require("../Thanks/styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const RequestFailed = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.REQUEST_FAILED),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.IconWrap, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ClearCircle, {
        fontSize: "inherit"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Header, {
      variant: "h5",
      component: "h5",
      color: "textPrimary",
      children: translations.requestFailed
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      textAlign: "center",
      color: "textPrimary",
      children: translations.pleaseTryAgainLater
    })]
  });
};
exports.RequestFailed = RequestFailed;